import { render } from "./SearchMember.vue?vue&type=template&id=f52b270e&scoped=true"
import script from "./SearchMember.vue?vue&type=script&lang=js"
export * from "./SearchMember.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f52b270e"]])

export default __exports__